module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "ex-ctr"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("I really need to thank:")])]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_vm._v("“El Pulpo,” for fixing my computer, sharing information about South American folklore, and most of all, cooking for me.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_vm._v("Juan Pablo, for sharing information about South American folklore and doing the dishes.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_vm._v("Raffaele, for the gnocchi, frutti di bosco, and panettone.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_vm._v("Adriana Groisman, for sharing information about Argentine politics and her husband Alberto’s cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_vm._v("My automatic writing partners:")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Alina Troyano, for writing with me and cooking for me.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Madeleine Olnek, for writing with me and cooking for me on the fabulous Ronco Showtime Rotisserie Oven.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Shirley Kwan, for writing with me and cooking for me.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Carol McCurdy, for writing with me and cooking for me.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_vm._v("Broadway, Pywackett and Kishka, for being great company.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_vm._v("Nicki, Garbo 180, and the Goddess, for bringing me luck and inspiration.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_vm._v("iMac, for cooking with me.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_vm._v("Vivian and Alejandra, for their scary witch stories and cooking for me on the Ronco Showtime Rotisserie Oven.")]), _vm._v(" "), _c('p', {
    staticClass: "gl"
  }, [_vm._v("Jennifer Enderlin, Sandra Martin, Lisa Hagen—even tho’ you never cooked for me, you have taken me out for lunch and dinner. I deeply appreciate the opportunities you have given me.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c150588c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 72
// module chunks = 0